import BaseStore from '../Base'
import _ from 'lodash'
import {Actions} from './Constants'
import {AuthConstants} from '../auth'

class UserStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))
      this._user = null
   }

   _subscribe(action) {
      switch (action.actionType) {
         case Actions.update:
            this._user = action.user
            this.emitChange()
            break

         case Actions.change:
            this._user = action.user
            this.emitChange()
            break

         case AuthConstants.Actions.logout:
            this._user = null
            this.emitChange()
            break

         default:
            break
      }
   }

   get user() {
      return _.clone(this._user)
   }
}

export default new UserStore()



// WEBPACK FOOTER //
// lib/api/user/Store.js